import React from "react";
import { Box, Card, Typography } from "@mui/material";

import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";

const SeasonEndRewards = () => {
  const rewardTiers = [
    { threshold: "> ₹50 Lakhs", reward: "₹10,000" },
    { threshold: "> ₹1 Crore", reward: "₹20,000" },
    { threshold: "> ₹3 Crore", reward: "₹1,00,000" },
    { threshold: "> ₹5 Crore", reward: "₹2,50,000" },
  ];

  const boxColors = [
    "rgba(220, 252, 231, 1)",
    "rgba(187, 247, 208, 1)",
    "rgba(134, 239, 172, 1)",
    "rgba(74, 222, 128, 1)",
  ];

  return (
    <Card
      sx={{
        width: "100%",
        maxWidth: 380,
        borderRadius: 4,
        p: 2.5,
        bgcolor: "white",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
        mx: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.5,
          mb: 2,
        }}
      >
        <Box
          sx={{
            width: "80px",
            height: "1px",
            background:
              "linear-gradient(90deg, #E0E0E0 0%, rgba(224, 224, 224, 0.3) 100%)",
          }}
        />
        <Typography
          sx={{
            fontSize: "12px",
            fontFamily: "Manrope",
            fontWeight: 500,
            lineHeight: "100%",
            letterSpacing: "0.8px",
            color: "rgba(0, 0, 0, 0.84)",
            whiteSpace: "nowrap",
            textTransform: "uppercase",
          }}
        >
          SEASON END REWARDS
        </Typography>
        <Box
          sx={{
            width: "80px",
            height: "1px",
            background:
              "linear-gradient(90deg, rgba(224, 224, 224, 0.3) 0%, #E0E0E0 100%)",
          }}
        />
      </Box>

      <Typography
        variant="body2"
        sx={{
          textAlign: "center",
          color: "rgba(0, 0, 0, 0.5)",
          mb: "1rem",
          fontSize: "10.61px",
          lineHeight: "15.1px",
          fontFamily: "Manrope, sans-serif",
          fontWeight: 500,
          letterSpacing: "0px",
          justifyContent: "center",
        }}
      >
        Season-end rewards based on Individual referred turnover:
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: "0.5rem",
        }}
      >
        <Box
          sx={{
            background:
              "linear-gradient(270deg, #FFFFFF -0.33%, #D9D9D9 109.54%)",
            borderTopLeftRadius: "7.65px",
            borderBottomLeftRadius: "7.65px",
            padding: "9.56px",
            display: "flex",
            alignItems: "center",
            gap: "9.56px",
          }}
        >
          <Typography
            sx={{
              width: "137px",
              height: "29px",
              fontFamily: "Manrope",
              fontWeight: 600,
              fontSize: "12px",
              lineHeight: "14.43px",
              letterSpacing: "0px",
              color: "rgba(0, 0, 0, 0.8)",
              paddingLeft: "0.5rem",
            }}
          >
            Referred Customer's
            <br />
            Turnover 💸*
          </Typography>
        </Box>

        <Box
          sx={{
            background:
              "linear-gradient(269.7deg, #78E5DD 2.16%, #FFFFFF 99.44%)",
            borderTopRightRadius: "7.65px",
            borderBottomRightRadius: "7.65px",
            padding: "9.5px",
            display: "flex",
            alignItems: "center",
            gap: "9.56px",
          }}
        >
          <Typography
            sx={{
              width: "85px",
              height: "15px",
              fontFamily: "Manrope",
              fontWeight: 600,
              fontSize: "12px",
              lineHeight: "14.43px",
              letterSpacing: "0px",
              color: "rgba(0, 0, 0, 1)",
            }}
          >
            Your Reward 🎁
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          width: "320px",
          border: "0.74px solid rgba(0, 0, 0, 0.2)",
          transform: "rotate(0deg)",
          marginBottom: "0.75rem",
          mx: "auto",
        }}
      />

      <Box sx={{ display: "flex", flexDirection: "column", gap: "7.04px" }}>
        {rewardTiers.map((tier, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: boxColors[index],
              p: 2,
              borderRadius:
                index === rewardTiers.length - 1 ? "0 0 12px 12px" : 0,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                color: "#333",
                fontSize: "16px",
              }}
            >
              {tier.threshold}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 600,
                color: "#333",
                fontSize: "16px",
              }}
            >
              {tier.reward}
            </Typography>
          </Box>
        ))}
      </Box>
    </Card>
  );
};

export default SeasonEndRewards;
